module.exports = __webpack_public_path__ + "static/hu-tao copy 2-371521772a15ebcd52241e6b702c4ed2.png";